module.exports = __webpack_public_path__ + "static/img/01.566d617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/11/01.jpg
// module id = Pm0G
// module chunks = 2